// extracted by mini-css-extract-plugin
export var orderDetails = "_uy-2";
export var orderImage = "_uy-1";
export var orderMeta = "_uy-3";
export var orderSummary = "_uy-0";
export var rightArrow = "_uy-4";